/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledSpecialRatesDiv = styled.div<{
  $buttonOffset?: number;
  $isNextGenHP?: boolean;
  $isDesktopView?: boolean;
  $showPointsAsCheckbox?: boolean;
}>`
  ${rtl`
  position: relative;
  padding-bottom: 0 !important;


  .m-dropdown-container {
    border-radius: ${toRem(8)};
  }
  .special-rates-dropdown .m-dropdown-children {
    padding: ${toRem(32)} ${toRem(24)};
    cursor: default;
    height: auto !important;
  }
  .m-dropdown-container {
    border-radius: ${toRem(8)};
  }
  .desktop-font-text-class{
     font-size: ${toRem(16)} !important;
  }
  .icon-arrow-down:before{
    height:${toRem(16)}
  }
  .icon-arrow-up:before{
    height:${toRem(16)}
  }
  .m-dropdown-action-bar {
    padding: ${toRem(24)} !important;
    position: fixed !important;
    bottom: 0;
    z-index: 1020;
    background: ${baseVariables.color['base20']} !important;
    @media ${baseVariables.mediaQuery.md} {
      padding-right: ${toRem(32)} !important;
      padding-left: ${toRem(32)} !important;
    }
  }

  .custom-input-padding {
    .m-input-text-field input[type=text]:not([type=submit]):not([type=button]):not([type=checkbox]):not([type=radio]) {
      border: ${toRem(1)} solid ${baseVariables.color['neutral40']} !important;
    }
    .m-input-text-field {
     label,
     input {
      cursor: text;
     }
    }
  }
  
  @media ${baseVariables.mediaQuery.md} {
    .icon-clear {
      padding-right: ${toRem(8)};
    }
  }
  label {
    margin-bottom: 0;
  }
  label: before {
    height: ${toRem(14)};
    width: ${toRem(14)};
  }
  label: after {
    background: none;
  }

.special-rates-text{
    padding: ${toRem(26)} ${toRem(40)} ${toRem(10)} ${toRem(16)} !important;
    cursor: pointer;
    text-overflow: ellipsis;
}
.m-input-text-field {
  label {
    cursor: pointer;
  }
}

.tabbed-radio-label {
  label {
    padding-left: ${toRem(28)};
  }
}

//mobie first approach
.dropdown-container{
  margin:0 auto;
}
.m-icon-text {
  .progress-status {
    color: ${baseVariables.color['neutral40']};
  }
}

/* NextGen standard: is-active/is-inactive styling for desktop and mobile */
.special-rates-input-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  
  &.is-inactive {
    .special-rates-icon-wrapper {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      
      .icon-member-rates1x {
        font-size: ${toRem(20)};
      }
    }
    
    .m-input-text-field {
      margin-bottom: 0;
      flex: 1;
      min-width: 0;
      
      label {
        position: absolute;
        width: ${toRem(1)};
        height: ${toRem(1)};
        padding: 0;
        margin: ${toRem(-1)};
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }
      
      /**
       * IMPORTANT: These styles use !important to prevent being overridden by
       * @marriott/global-styles which gets dynamically loaded when the sign-in
       * modal opens. The global-styles contains a generic .m-input-text-field
       * input[type=text] selector that would otherwise override our custom styling.
       * See WEB-183120 for details.
       */
      input[type='text'].special-rates-input-field {
        border: none !important;
        padding: 0 0 0 ${toRem(8)} !important;
        line-height: 0 !important;
        font-size: ${toRem(14)} !important;
        font-weight: 500 !important;
        color: ${baseVariables.color.neutral40} !important;
        height: auto !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        width: var(--input-ch-width, auto);
        
        @media ${baseVariables.mediaQuery.lg} {
          max-width: ${toRem(247)}; /* WEB-213501: desktop only */
          font-size: ${toRem(16)} !important;
        }
        
        &.special-rates-text {
          padding: 0 0 0 ${toRem(8)} !important;
        }
      }
    }
    
    /* Hide trailing icon in inactive state */
    .trailing-element {
      display: none;
    }
  }
  
  &.is-active {
    display: block;
    
    .special-rates-icon-wrapper {
      display: none;
    }
    
    .m-input-text-field {
      label {
        display: block;
      }
      
      /**
       * IMPORTANT: These styles use !important to prevent being overridden by
       * @marriott/global-styles. See comment above for details (WEB-183120).
       */
      input[type='text'].special-rates-input-field {
        font-size: ${toRem(16)} !important;
        font-weight: 700 !important;
      }
    }
    
    .trailing-element {
      display: flex;
    }
  }

  // Add focus styling only when special rates dropdown is actually open
  // Target when the component has both is-active class AND dropdown-open class
  &.is-active.dropdown-open .m-input-text-field input[type='text'].special-rates-input-field {
    border: ${toRem(1.5)} ${baseVariables.border.borderStyleDefault} ${baseVariables.color.base10}
  }
}

.special-rates-tooltip-container {
  position: relative;
}

.special-rates-dropdown .header-heading {
  font-size: ${toRem(18)} !important;
}

.special-rates-dropdown .points-awards-title {
  font-family: ${baseVariables.font['fontFamilySwiss']} !important;
}

.ng-special-rates-points-tooltip .ng-points-tooltip-row {
  position: absolute;
  right: calc(100% - ${toRem(208)});
}

.special-rates-tooltip-container .ng-points-tooltip-row {
  position: absolute;
  top: calc(100% + ${toRem(8)});
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  justify-content: flex-start;
}
.m-input-text-field-no-border input[type='text'] {
  line-height: ${toRem(22)} !important;
  padding-top: ${toRem(5)} !important;
}
.m-dropdown-children .t-label-xs {
  letter-spacing: ${toRem(1.2)};
}
.m-icon-button-secondary {
  padding: 0;
}
.m-dropdown-children{
  position: relative;
  padding: ${toRem(8)} 0 ${toRem(8.5)}  ${toRem(1)};
}
input[type=radio]:checked~label:before {
  outline:none !important;
}
input[type=radio]:checked~label {
  font-weight:${baseVariables.font.fontWeightRegular};
}
input[type=radio] + label {
  font-weight:${baseVariables.font.fontWeightRegular};
}

.special-rates-input-container
  input[type='text']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    font-weight:${baseVariables.font.fontWeightMedium};
}

.m-dropdown-header{
  position: sticky;
  top: 0;
  background: ${baseVariables.color['base20']};
  z-index: 1;
  border-bottom:unset;
  padding: 0 0 ${toRem(1)} 0;
  &:after{
    content: "";
    position: absolute;
    left: 50%;
    top: ${toRem(66)};
    transform: translateX(-50%);
    width: 100%;
    border-bottom: 0;
  }
}
.m-dropdown-cont {
  .m-dropdown-header{
    padding: 0;
  }
}

.dropdown-to-modal{
  height:80vh;
  padding: ${toRem(24)} ${toRem(16)};
  position:fixed;
}

.dropdown-to-modal .m-dropdown-action-bar {
  bottom:env(safe-area-inset-bottom);
  border-radius: 0;
}

.tabbed-dropdown-container .dropdown-to-modal-background .dropdown-to-modal .m-dropdown-content {
  height: calc(80vh - ${toRem(60)});
}

.divider {
  border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
}

@media ${baseVariables.mediaQuery.md} {
  .tabbed-dropdown-container {
    .dropdown-to-modal-background {
      .dropdown-to-modal {
        padding-left: ${toRem(32)};
      }
    }
  }
}

@media ${baseVariables.mediaQuery.desktop} {
  
  .dropdown-container{
    z-index:1;
    position:absolute;
    width:${toRem(348)};
    left: ${(props: { $isNextGenHP?: boolean; $buttonOffset?: number; $isDesktopView?: boolean }) =>
      props.$isNextGenHP && props.$isDesktopView ? `${props.$buttonOffset || 0}px` : '12px'};
    margin: 0;
    border-radius: ${toRem(8)};
    padding-top: ${toRem(4)};
    & >div:first-child {
      z-index:1001;
      bottom: unset;
      width: unset;
      height: fit-content;

      & >div:first-child {
        height:fit-content;
      }
    }
  }
  
  /* NextGen standard: Left align dropdown in default mode */
  ${(props: { $showPointsAsCheckbox?: boolean }) =>
    !props.$showPointsAsCheckbox &&
    `
    &.is-active .dropdown-container {
      left: 0 !important;
    }
  `}
  
  /* NextGen standard: Right align dropdown in checkbox mode */
  ${(props: { $showPointsAsCheckbox?: boolean }) =>
    props.$showPointsAsCheckbox &&
    `
    &.is-active .dropdown-container {
      right: 0 !important;
      left: auto;
      z-index: 2;
    }
  `}

  .tabbed-dropdown-container {
    margin: ${toRem(4)} auto;
  }

  .m-dropdown-children{
    padding: ${toRem(32)} ${toRem(24)};
  }
  .apply-button-desktop{
    margin-top: ${toRem(24)};
    display: flex;
    justify-content: flex-end;
  }
  .apply-btn {
    margin-top: ${toRem(20)};
  }
  .tabbed-promo-code .m-input-text-field-no-border .trailing-element {
    bottom: ${toRem(2)};
  }
  .tabbed-promo-code .m-input-text-field-no-border {
    &:after{
      top: ${toRem(46)};
    }
  }
  .top-spacing-class{
    margin-top: ${toRem(13)};
  }

}
  .availability-corp-code {
    .m-input-text-field-no-border {
      display: flex;
      flex-direction: column;
    }
    .trailing-element {
      bottom: ${toRem(30)};
    }
    .error-message {
      color: ${baseVariables.color.alert40} !important;
      padding-top: ${toRem(8)}
    }
  }
    
.custom-input-padding .m-input-text-field {
  display: grid;
  grid-template-columns: 1fr;
  position: relative;

  > input {
    grid-row: 1;
    grid-column: 1;
  }

  > .trailing-element {
    grid-row: 1;
    grid-column: 1;
    justify-self: end;
    align-self: center;
    position: relative;
    right: unset;
    bottom: unset;
    margin-right: ${toRem(16)};
    z-index: 1;
  }

  &.is-error {
    grid-template-rows: auto auto;
    row-gap: ${toRem(8)};

    > .error-message {
      grid-row: 2;
      grid-column: 1;
      color: ${baseVariables.color.alert40} !important;
    }
  }
}

`}
`;
